/** Buttons in the sticky sheet drive the existing PDP picker and its variant pipeline. */
class StickyStemsSelector extends HTMLElement {
  #controller;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.addEventListener('click', this.#onClick, { signal });
    this.closest('.shopify-section')?.addEventListener('change', this.#onMainChange, { signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #getPicker() {
    const sticky = this.closest('sticky-add-to-cart');
    return sticky?.closest('.shopify-section')?.querySelector(
      `variant-picker[data-product-id="${CSS.escape(sticky.dataset.productId)}"]`
    );
  }

  #onClick = (event) => {
    const item = event.target.closest('.sticky-stems__item');
    if (!item || !this.contains(item)) return;
    const picker = this.#getPicker();
    if (!picker) return;
    const position = Number(this.dataset.optionPosition || 1);
    const fieldsets = picker.querySelectorAll('fieldset');
    const scope = fieldsets[position - 1] || picker;
    const input = Array.from(scope.querySelectorAll('input[type="radio"]')).find(input => input.value === item.dataset.value);
    if (input) {
      if (input.checked) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      const select = picker.querySelectorAll('select')[position - 1];
      if (!select || select.value === item.dataset.value) return;
      select.value = item.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    this.selectValue(item.dataset.value);
  };

  #onMainChange = (event) => {
    const picker = this.#getPicker();
    if (!picker?.contains(event.target)) return;
    const position = Number(this.dataset.optionPosition || 1);
    const fieldset = picker.querySelectorAll('fieldset')[position - 1];
    const select = picker.querySelectorAll('select')[position - 1];
    if ((fieldset?.contains(event.target) && event.target.matches('input[type="radio"]')) || event.target === select) {
      this.selectValue(event.target.value);
    }
  };

  selectValue(value) {
    const matching = Array.from(this.querySelectorAll('.sticky-stems__item')).find(item => item.dataset.value === value);
    if (!matching) return;
    this.querySelector('.sticky-stems__selected-label').textContent = value;
    this.querySelectorAll('.sticky-stems__item').forEach(item => {
      const selected = item === matching;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', String(selected));
    });
    const summary = this.closest('sticky-add-to-cart')?.querySelector('[ref="selectedLabel"]');
    if (summary) summary.textContent = value;
  }
}

if (!customElements.get('sticky-stems-selector')) {
  customElements.define('sticky-stems-selector', StickyStemsSelector);
}
